import { render, staticRenderFns } from "./ExpirySyncDate.vue?vue&type=template&id=5f321f88"
import script from "./ExpirySyncDate.vue?vue&type=script&lang=js"
export * from "./ExpirySyncDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports